jQuery(document).ready(function(){
	
//------------------new-------------------

  jQuery('button.pause_btn').on('click',function(){
      jQuery(this).addClass('hide');
      jQuery('button.plaY_btn').removeClass('hide');

      jQuery("video#sampleMovie").get(0).pause();
  });
  jQuery('button.plaY_btn').on('click',function(){
      jQuery('button.pause_btn').removeClass('hide');
      jQuery(this).addClass('hide');
      jQuery("video#sampleMovie").get(0).play();
  });
//eo
//---------------contact page ------------------
  if(!jQuery('div.form-success').hasClass('hide')){
	jQuery('div.contact-page').addClass('success_message_present');
    //jQuery('div#col-main').addclass('success_reviled');
}
jQuery('input.btn.btn-custom').click(function(){
  	var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	var email = jQuery('input#email').val();
    if(!jQuery('form#contact_form div.form-success').hasClass('hide')){
		jQuery('div.contact-page').addClass('success_message_present');
	}
	if( jQuery('input#email').val() == ''){ 
      jQuery('input#email').parent().addClass('invalid');return false;
    }
  	else{ 
      if(!regex.test(email)){
        if( !jQuery('input#email').parent().hasClass('invalid')){
          jQuery('input#email').parent().addClass('invalid');
        } 
      	return false;
      }else{
      	if( jQuery('input#email').parent().hasClass('invalid')){
      		jQuery('input#email').parent().removeClass('invalid');
      	} 
      }
    }
	if( jQuery('textarea#message').val() == ''){
      jQuery('textarea#message').parent().addClass('invalid');return false;
    }else{
      if( jQuery('textarea#message').parent().has('invalid')){
      	jQuery('textarea#message').parent().removeClass('invalid');
      }      
    } 
});
//eo
});